<template>
  <h1>Configuração do Jogo</h1>
</template>

<script>
export default {
  name:'Configuracao'
}
</script>

<style>

</style>
